import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';
import ICONS from '../../../../constants/icons';
import routes from '../../../../constants/routes';

interface DatasetComponentNoteProps {
    datasetId: number;
    note: string;
}

const DatasetComponentNote: FC<DatasetComponentNoteProps> = ({
    datasetId,
    note,
}) => {
    return (
        <DatasetComponentNoteContainer>
            <TextContainer>
                <Text>{note}</Text>
                <DatasetLink
                    to={routes.datasetsView(datasetId)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Dataset
                    <ICONS.externalLink
                        size={12}
                        color={aampeTheme.colors.solidA01}
                    />
                </DatasetLink>
            </TextContainer>
        </DatasetComponentNoteContainer>
    );
};

const DatasetComponentNoteContainer = styled.div({
    width: '100%',
    padding: aampeTheme.spacing4(2, 4),
    background: aampeTheme.colors.backgroundWG02,
    borderTop: `1px solid ${aampeTheme.colors.interactiveWG01}`,
});

const TextContainer = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
});

const Text = styled.div({
    color: aampeTheme.colors.textAccessibleWG01,
    fontSize: aampeTheme.size.font.default,
    fontWeight: 400,
    lineHeight: '24px',
});

const DatasetLink = styled(Link)({
    display: 'flex',
    gap: aampeTheme.spacing4(1),
    alignItems: 'center',
    color: aampeTheme.colors.solidA01,
    textDecoration: 'none',
});

export default DatasetComponentNote;
